import { request } from "../../../../../api/api"

export const getAdvanceAnalyticsPieChartDataApi = (params) => {
    return request.post(`/advance/getAdvanceAnalyticsProductionAvailabilityCOCPieChartData/`, params)
}


export const getCompanyById = (id) => {
    return request.get(`/client_managent/getCompanyList/${id}/`)
}